const STORAGE_KEY_RECENT_HISTORY = "recpd";

export function saveRecentProductHistory(cartItemLength) {
  window.localStorage.setItem(STORAGE_KEY_RECENT_HISTORY, cartItemLength);
}

export function loadRecentProductHistory() {
  return window.localStorage.getItem(STORAGE_KEY_RECENT_HISTORY);
}

export function removeRecentProductHistory() {
  window.localStorage.removeItem(STORAGE_KEY_RECENT_HISTORY);
}
